import metaStoreService from "../../../../../core/services/metaStoreService/meta-store-service";
import utils from "../../../../../core/utils";
import { DEFAULT_PERFORMANCE_SETTINGS, STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS } from "./sentinel-panel-consts";

const handleNameValidation = async (value: string, metaObjectType: string, nsName: string) => {
    if (!value) {
        return "required";
    }
    if (/\s/.test(value)) {
        return "noSpaces";
    }
    if (/\W/g.test(value)) {
        return "invalidFormat";
    }
    if (/^\d/.test(value)) {
        return "startsWithNumber";
    }
    const isDuplicate = await metaStoreService
        .findById(nsName + "." + metaObjectType + "." + value)
        .then(item => !!item);
    if (isDuplicate) {
        return "duplicate";
    }
    return false;
};


type PerformanceSettingsValues = {
    batchSize: string;
    batchTimeout: string;
    parallelRequestCount: string;
    striimAIMode: string | {
        label: string;
        value: string;
    };
} | null


const setCurrentOrDefaultPerformanceSettings = (properties: PerformanceSettingsValues, isStriimAIEngine: boolean) => {
    const striimAIMode = typeof properties?.striimAIMode === "object" ? properties.striimAIMode.value : properties?.striimAIMode;
    return {
        batchSize: properties?.batchSize
            ? properties.batchSize
            : isStriimAIEngine
                ? STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS.batchSize
                : DEFAULT_PERFORMANCE_SETTINGS.batchSize,
        batchTimeout: properties?.batchTimeout ? properties.batchTimeout : isStriimAIEngine ? STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS.batchTimeout : DEFAULT_PERFORMANCE_SETTINGS.batchTimeout,
        parallelRequestCount: properties?.parallelRequestCount
            ? properties.parallelRequestCount
            : DEFAULT_PERFORMANCE_SETTINGS.parallelRequestCount,
        striimAIMode: {
            label: striimAIMode
                ? utils.capitalize(striimAIMode)
                : STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS.striimAIMode,
            value: striimAIMode ?? STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS.striimAIMode.toUpperCase()
        }
    };
};

export { handleNameValidation, setCurrentOrDefaultPerformanceSettings }